const getRepaymentString = (monthCount) => {
  function getPlural(number, word) {
    return number === 1 && word.one || word.other;
  }

  const months = { one: 'maand', other: 'maanden' };
  const years = { one: 'jaar', other: 'jaren' };
  const m = monthCount % 12;
  const y = Math.floor(monthCount / 12);
  const result = [];

  if (y) {
    result.push(y + ' ' + getPlural(y, years));
  }
  if (m) {
    result.push(m + ' ' + getPlural(m, months));
  }
  return result.join(' en ');
};

export default getRepaymentString;
